/* Foil & Foundry Co. theme script: cart drawer, quick add, variant picker, filters, menu */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const CFG = window.MEZ || {};
  const root = (CFG.routes && CFG.routes.root) || "/";

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    format = format || CFG.moneyFormat || "${{amount}}";
    cents = Number(cents) || 0;
    const fmt = (n, d, t, s) => {
      const [i, f] = (n / 100).toFixed(d).split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : "");
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case "amount_no_decimals": return fmt(cents, 0, ",", ".");
        case "amount_with_comma_separator": return fmt(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return fmt(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator": return fmt(cents, 2, "'", ".");
        default: return fmt(cents, 2, ",", ".");
      }
    });
  }
  window.MEZ_formatMoney = formatMoney;
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  /* ---------- toast ---------- */
  let tt;
  function toast(msg) {
    const t = $("#mez-toast"); if (!t) return;
    t.textContent = msg; t.hidden = false; clearTimeout(tt);
    tt = setTimeout(() => (t.hidden = true), 2200);
  }

  /* ---------- cart ---------- */
  const drawer = $("#cart-drawer"), scrim = $("#cart-scrim");
  function openCart(open) {
    if (!drawer) return;
    drawer.hidden = !open; scrim.hidden = !open;
    if (open) { $("#cart-close") && $("#cart-close").focus(); }
  }
  async function getCart() { const r = await fetch(root + "cart.js", { headers: { Accept: "application/json" } }); return r.json(); }
  async function changeLine(key, quantity) {
    const r = await fetch(root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity }) });
    const data = await r.json();
    if (!r.ok) { toast(data.description || data.message || "We couldn't update your cart."); return getCart(); }
    return data;
  }
  function renderCart(cart) {
    $$("[data-cart-count]").forEach((e) => (e.textContent = cart.item_count));
    if (!drawer) return;
    const threshold = Number(drawer.dataset.freeShip || 0) * 100 * (window.Shopify && Shopify.currency && Shopify.currency.rate ? Number(Shopify.currency.rate) : 1);
    const sub = cart.total_price;
    const ship = $("#cart-ship");
    if (ship) {
      if (threshold > 0) {
        const left = threshold - sub;
        ship.hidden = false;
        ship.innerHTML = (left > 0 ? `Add <b>${formatMoney(left)}</b> more for free tracked shipping` : `<b style="color:var(--good)">You've unlocked free tracked shipping</b>`) +
          `<div class="meter"><i style="width:${Math.min(100, (sub / threshold) * 100)}%"></i></div>`;
      } else ship.hidden = true;
    }
    $("#cart-subtotal").textContent = formatMoney(sub);
    $("#cart-checkout").disabled = cart.item_count === 0;
    const items = $("#cart-items");
    items.innerHTML = cart.items.length
      ? cart.items.map((it) => {
          const img = it.featured_image && it.featured_image.url ? `<img src="${esc(it.featured_image.url)}&width=120" alt="" loading="lazy">` : `<div class="cardart"><div class="win"></div><div class="bar"></div></div>`;
          const opts = (it.options_with_values || []).filter((o) => o.value !== "Default Title").map((o) => esc(o.value)).join(" · ");
          return `<div class="line">${img}<div><p><a href="${esc(it.url)}" style="text-decoration:none">${esc(it.product_title)}</a></p>${opts ? `<small>${opts}</small>` : ""}
            <div class="lq"><button type="button" data-line="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Decrease quantity">−</button><span class="mono">${it.quantity}</span><button type="button" data-line="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Increase quantity">+</button><button type="button" class="rm" data-line="${esc(it.key)}" data-q="0">Remove</button></div></div>
            <b class="mono">${formatMoney(it.final_line_price)}</b></div>`;
        }).join("")
      : `<p style="color:var(--muted);padding:24px 0">Your cart is empty. Singles go fast, so grab what you need.</p>`;
  }
  async function refreshCart(open) { const c = await getCart(); renderCart(c); if (open) openCart(true); }

  async function addToCart(form, btn) {
    const fd = new FormData(form);
    const label = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
    try {
      const r = await fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: fd });
      const data = await r.json();
      if (!r.ok) { toast(data.description || "That item couldn't be added. It may have just sold."); return; }
      if (btn) { btn.classList.add("added"); btn.textContent = "Added"; }
      toast(`Added ${data.product_title || "item"} to your cart`);
      if (CFG.cartType === "drawer") await refreshCart(true); else window.location.href = root + "cart";
    } catch (e) { toast("Network problem. Please try again."); }
    finally {
      if (btn) setTimeout(() => { btn.disabled = false; btn.classList.remove("added"); btn.innerHTML = label; }, 1400);
    }
  }

  document.addEventListener("submit", (e) => {
    const f = e.target.closest("form[data-add-form]");
    if (!f || CFG.cartType !== "drawer") return;
    e.preventDefault();
    addToCart(f, f.querySelector("[type=submit]"));
  });
  document.addEventListener("click", async (e) => {
    const lb = e.target.closest("[data-line]");
    if (lb) { lb.disabled = true; const c = await changeLine(lb.dataset.line, Number(lb.dataset.q)); renderCart(c); if (location.pathname.endsWith("/cart")) location.reload(); return; }
    if (e.target.closest("[data-open-cart]") && CFG.cartType === "drawer") { e.preventDefault(); refreshCart(true); return; }
    if (e.target.closest("#cart-close") || e.target === scrim) openCart(false);
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") openCart(false); });

  /* ---------- mobile menu ---------- */
  const menuBtn = $("#menu-btn"), nav = $("#main-nav");
  if (menuBtn && nav) menuBtn.addEventListener("click", () => { const o = nav.classList.toggle("open"); menuBtn.setAttribute("aria-expanded", o); });

  /* ---------- collection filters ---------- */
  $$("form[data-facets]").forEach((form) => {
    let t;
    form.addEventListener("change", () => { clearTimeout(t); t = setTimeout(() => form.requestSubmit ? form.requestSubmit() : form.submit(), 250); });
    form.addEventListener("submit", () => {
      // drop empty price inputs so the URL stays clean
      $$("input[type=number]", form).forEach((i) => { if (i.value === "") i.disabled = true; });
    });
  });
  $$("select[data-sort]").forEach((s) => s.addEventListener("change", () => {
    const u = new URL(location.href); u.searchParams.set("sort_by", s.value); u.searchParams.delete("page"); location.href = u.toString();
  }));
  const ft = $("[data-filter-toggle]");
  if (ft) ft.addEventListener("click", () => { const f = $(".facets"); const o = f.classList.toggle("open"); ft.setAttribute("aria-expanded", o); });

  /* ---------- product variant picker ---------- */
  $$("[data-product]").forEach((el) => {
    const dataEl = $("script[data-product-json]", el);
    if (!dataEl) return;
    const product = JSON.parse(dataEl.textContent);
    const idInput = $("input[name=id]", el);
    const priceEl = $("[data-price]", el), stockEl = $("[data-stock]", el), btn = $("[data-add-btn]", el);
    const mainImg = $("[data-main-img]", el);
    const fieldsets = $$("fieldset[data-option-index]", el);
    function selected() { return fieldsets.map((fs) => { const c = $("input:checked", fs); return c ? c.value : null; }); }
    function find(opts) { return product.variants.find((v) => v.options.every((o, i) => o === opts[i])); }
    function update() {
      const opts = selected();
      // mark values that have no in-stock variant given the other selections
      fieldsets.forEach((fs, idx) => {
        $$("input", fs).forEach((inp) => {
          const test = opts.slice(); test[idx] = inp.value;
          const v = find(test);
          inp.classList.toggle("na", !v || !v.available);
        });
      });
      const v = find(opts);
      if (!v) { btn.disabled = true; btn.textContent = "Unavailable"; stockEl.className = "stock out"; stockEl.textContent = "This combination isn't stocked."; return; }
      idInput.value = v.id;
      priceEl.innerHTML = formatMoney(v.price) + (v.compare_at_price > v.price ? ` <s>${formatMoney(v.compare_at_price)}</s>` : "");
      if (v.available) {
        btn.disabled = false; btn.textContent = "Add to cart";
        const q = v.inventory_quantity;
        if (v.inventory_management && q > 0 && q <= 3) { stockEl.className = "stock low"; stockEl.textContent = `Only ${q} left in this condition`; }
        else { stockEl.className = "stock in"; stockEl.textContent = "In stock, ships in 1–2 business days"; }
      } else { btn.disabled = true; btn.textContent = "Sold out"; stockEl.className = "stock out"; stockEl.textContent = "Sold out in this condition. Try another option above."; }
      if (v.featured_image && mainImg) mainImg.src = v.featured_image;
      const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u.toString());
    }
    fieldsets.forEach((fs) => fs.addEventListener("change", update));
    update();
    // thumbnails
    $$("[data-thumb]", el).forEach((b) => b.addEventListener("click", () => {
      mainImg.src = b.dataset.thumb; $$("[data-thumb]", el).forEach((x) => x.setAttribute("aria-current", x === b));
    }));
    // quantity stepper
    const q = $("input[name=quantity]", el);
    $$("[data-qty]", el).forEach((b) => b.addEventListener("click", () => { q.value = Math.max(1, (Number(q.value) || 1) + Number(b.dataset.qty)); }));
  });

  if (CFG.cartType === "drawer" && drawer) refreshCart(false);
})();

/* ===== Foil & Foundry: $5.00 minimum order (cart drawer) ===== */
(function () {
  var MIN = 500; // $5.00 in cents
  var timer = null;

  function money(c) { return '$' + (c / 100).toFixed(2); }

  function shippingBars() {
    var bars = [];
    document.querySelectorAll('.meter').forEach(function (m) {
      var box = m.parentElement;
      if (box && !box.classList.contains('ff-min') && /free tracked shipping/i.test(box.textContent)) bars.push(box);
    });
    return bars;
  }

  function checkoutButtons() {
    return document.querySelectorAll('[name="checkout"], a[href*="/checkout"]');
  }

  function apply(total) {
    var under = total < MIN;

    shippingBars().forEach(function (box) {
      var note = box.previousElementSibling;
      if (!note || !note.classList.contains('ff-min')) note = null;
      if (under) {
        box.style.display = 'none';
        if (!note) {
          note = document.createElement('div');
          note.className = 'ff-min';
          note.style.fontSize = '13px';
          box.parentNode.insertBefore(note, box);
        }
        if (note.dataset.total !== String(total)) {
          note.dataset.total = String(total);
          var pct = Math.round(total * 100 / MIN);
          note.innerHTML = 'Add <b>' + money(MIN - total) + '</b> more to reach our <b>$5.00 order minimum</b>' +
            '<div class="meter"><i style="width:' + pct + '%;background:#E3A93B"></i></div>';
        }
      } else {
        box.style.display = '';
        if (note) note.remove();
      }
    });

    checkoutButtons().forEach(function (b) {
      if (under) {
        if (b.dataset.ffLocked) return;
        b.dataset.ffLocked = '1';
        b.dataset.ffLabel = b.innerHTML;
        b.innerHTML = '$5.00 minimum to check out';
        b.setAttribute('aria-disabled', 'true');
        b.style.opacity = '.5';
        b.style.pointerEvents = 'none';
        if ('disabled' in b) b.disabled = true;
      } else if (b.dataset.ffLocked) {
        b.innerHTML = b.dataset.ffLabel;
        delete b.dataset.ffLocked;
        b.removeAttribute('aria-disabled');
        b.style.opacity = '';
        b.style.pointerEvents = '';
        if ('disabled' in b) b.disabled = false;
      }
    });
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      if (!shippingBars().length && !checkoutButtons().length) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { apply(cart.total_price); })
        .catch(function () {});
    }, 150);
  }

  function start() {
    new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true, characterData: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
